var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcPhotoframe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 76,
  height: 71,
  fill: "none",
  viewBox: "0 0 76 71"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F1F1F1",
  d: "M4 0h72v67H4V0Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#75899D",
  strokeWidth: 2,
  d: "M1 5h70v65H1V5Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#C7CDDD",
  d: "m2 53 16.5-21.5L38 53l15-16.5 17 23V69H2V53Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#FDC526",
  strokeWidth: 2,
  d: "M55.305 27a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#C7CDDD",
  fillRule: "evenodd",
  d: "M30 17H10v-2h20v2ZM18.951 22h-8.78v-2h8.78v2Z",
  clipRule: "evenodd"
})));
export { SvgIcPhotoframe as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzYiIGhlaWdodD0iNzEiIHZpZXdCb3g9IjAgMCA3NiA3MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQgMEg3NlY2N0g0VjBaIiBmaWxsPSIjRjFGMUYxIi8+CjxwYXRoIGQ9Ik0xIDVINzFWNzBIMVY1WiIgZmlsbD0id2hpdGUiIHN0cm9rZT0iIzc1ODk5RCIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0yIDUzTDE4LjUgMzEuNUwzOCA1M0w1MyAzNi41TDcwIDU5LjVWNjlIMlY1M1oiIGZpbGw9IiNDN0NEREQiLz4KPHBhdGggZD0iTTU1LjMwNDcgMjdDNTkuNDQ2OCAyNyA2Mi44MDQ3IDIzLjY0MjEgNjIuODA0NyAxOS41QzYyLjgwNDcgMTUuMzU3OSA1OS40NDY4IDEyIDU1LjMwNDcgMTJDNTEuMTYyNiAxMiA0Ny44MDQ3IDE1LjM1NzkgNDcuODA0NyAxOS41QzQ3LjgwNDcgMjMuNjQyMSA1MS4xNjI2IDI3IDU1LjMwNDcgMjdaIiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSIjRkRDNTI2IiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zMCAxN0gxMFYxNUwzMCAxNVYxN1oiIGZpbGw9IiNDN0NEREQiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOC45NTE0IDIySDEwLjE3MDlWMjBIMTguOTUxNFYyMloiIGZpbGw9IiNDN0NEREQiLz4KPC9zdmc+Cg==";